module.exports = __webpack_public_path__ + "static/kavin-99bf85091ed5e937c34bcdf06964a181.jpg";